import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ViewManagementModel} from '../_models/viewManagement.model';

@Injectable({providedIn: 'root'})

export class TopManagementService {
    constructor(private http: HttpClient) {
    }

    userConsent(id, consent) {
        return this.http.put('agri/crm/addTopManagementConsent?topManagementId=' + id + '&accept=' + consent, {});
    }

    checkIfUserConsent(id) {
        return this.http.get('/agri/crm/isInTMConsentList?topManagementId=' + id)
    }

    createTopManagement(managementData) {
        return this.http.post('agri/crm/createTopManagement', managementData);
    }

    editTopManagement(id, postData) {
        return this.http.put('/agri/crm/updateTopManagement?topManagementId=' + id, postData);
    }

    viewTopManagement(postId: string) {
        return this.http.get('agri/crm/getTopManagementById?topManagementId=' + postId);
    }

    listTopManagementFilter(size, page, sort, orderDir, filterData: object) {
        return this.http.post<ViewManagementModel>('agri/listTopManagementFiltered?page=' + (page - 1) + '&size=' + size + '&sort=' + sort + '&dir=' + orderDir, filterData);
    }
}
